module.exports = __webpack_public_path__ + "media/images/river-5e1bf597c3996188b4ef83158bf6af70.png";